module.exports = __webpack_public_path__ + "assets/img/btn-detail-2793ebe7.png";